import { Tab, Tabs } from "@mui/material"
import { useState } from "react"
import AppCollection from "./AppCollection"
import PromoCard from "./PromoCard"

const PageTabsLayout = ({ tab, tabItems }) => {
  const [currentTab, setTab] = useState(0)
  const handleTabChange = (e, val) => setTab(val)

  const { appCollection, promoCard } = tabItems[currentTab]

  return (
    <>
      {tabItems.length > 1 && <Tabs
        value={currentTab}
        onChange={handleTabChange}
        centered
      >
        {tabItems.map((tabItem, i) => (
          <Tab key={i} label={tabItem.appCollection.title} value={i} />
        ))}
      </Tabs>}

      <div style={{ height: '100%', overflowY: 'scroll', padding: '1rem 0 0' }}>
        {appCollection && <AppCollection
          id={appCollection.id}
          total={appCollection.total}
          limit={appCollection.limit}
          title={appCollection.title}
          layout={"chart"}
          cardType={"small"}
          showIcon={true}
          showBanner={false}
          showVideo={false}
          apps={appCollection.apps}

          // reporting
          tab={tab}
          appCollection={appCollection}
        />}

        {promoCard && <PromoCard
          imageUrl={promoCard.imageUrl}
          title={promoCard.title}

          // reporting
          tab={tab}
          promoCard={promoCard}
        />}
      </div>
    </>
  )
}

export default PageTabsLayout
